<template>
  <div class="content">
    <div style="width: 100%;height: 2rem;background-color: #fff">
      <div style="width: 100%;height: .8rem;background-color: #87CEFA;text-align: center;line-height: .8rem;color: #fff">
        {{$route.query.name}}
      </div>
      <div style="width: 100%;height: 1.2rem">
        <el-row>
          <el-col :span="11">
            <div style="height: .6rem;line-height: .7rem;text-align: center">姓名</div>
            <div style="height: .6rem;line-height: .5rem;text-align: center;color: #87CEFA">{{$storage.get('patient').clinic_patient_name}}</div>
          </el-col>
          <el-col :span="2">
            <div style="height: 1.2rem;width: 100%;text-align: center;font-size: .4rem;color: #999999;line-height: 1.2rem">|</div>
          </el-col>
          <el-col :span="11">
            <div style="height: .6rem;line-height: .7rem;text-align: center">年龄</div>
            <div style="height: .6rem;line-height: .5rem;text-align: center;color: #87CEFA">{{$storage.get('patient').QrAge}}岁</div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div style="width: 90%;height: 1rem;margin: 0 auto;line-height: 1rem;font-size: .32rem">
      报告单号：{{$route.query.id}}
    </div>
    <div v-if="jyList.length>0">
      <el-table :data="jyList" style="width: 100%" border :header-cell-style="{background:'#87CEFA',color:'#fff'}">
        <el-table-column prop="检查项目" label="检查项目" width="140" align="center"></el-table-column>
        <el-table-column prop="结果" label="结果" min-width="20" align="center"></el-table-column>
        <el-table-column prop="参考值" label="参考值" min-width="30" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="noCard" v-if="!jyList.length>0">
      <div class="noCard-img">
        <img src="static/img/noCard.png"/>
      </div>
      <div class="noCard-text">暂无数据</div>
    </div>
  </div>
</template>

<script>
  import {getreportjyInfo} from '../../api/index'
    export default {
      data(){
        return{
          jyList:[]
        }
      },
      created() {
        //修改标题
        document.title = '检验详情'
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        getreportjyInfo({
          reportId:this.$route.query.id
        }).then(res=>{
          loading.close();
          this.jyList = res.Data
        })
      }
    }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    font-size: .3rem;
  }
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 4rem 0;
    background-color: #ffffff;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/jyreport.vue